import * as React from "react";
import Loader from "./loader";
import { options } from "./options";

interface PageLoaderProps {
  isVisible?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = (props: PageLoaderProps) => {
  const { isVisible } = props;
  return (
    <div
      className="animHolder"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        maxWidth: "90px",
      }}
    >
      <Loader isVisible={isVisible} animationData={options.loading1} />
    </div>
  );
};

PageLoader.defaultProps = {
  isVisible: true,
};

export default PageLoader;
